import {Card} from "shared-portal-component";

const ActivityLog = () => <Card>Activity Log was not in design</Card>;

export default ActivityLog;
